import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Select, DatePicker, Input, Divider, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Option } = Select;

const useEventFields = (enums, loading) => {
  const { t } = useTranslation();
  const dateFormat = 'DD-MM-YYYY';
  const today = moment();
  const [newOption, setNewOption] = useState();
  const [dataList, seTDataList] = useState([]);

  const onNameChange = (event) => {
    setNewOption(event.target.value);
  };

  const addItem = () => {
    seTDataList([...dataList, newOption]);
  };
  const eventFields = [
    {
      name: ['event', 'name'],
      rules: [{ required: true }],
      input: <Input row={4} />
    },
    {
      name: ['event', 'type'],
      rules: [{ required: true }],
      input: enums ? (
        <Select
          showSearch
          loading={loading}
          style={{ width: 240 }}
          placeholder="Choisir un type"
          dropdownRender={(menu) => (
            <div>
              {menu}
              <Divider style={{ margin: '4px 0' }} />
              <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                <Input
                  style={{ flex: 'auto' }}
                  value={newOption}
                  onChange={onNameChange}
                />
                <Button onClick={() => addItem()}>
                  <PlusOutlined />
                  {t(`projects.form.factors.title`)}
                </Button>
              </div>
            </div>
          )}
        >
          {enums.event_types.map((ele) => (
            <Option key={ele}>{ele}</Option>
          ))}
          {dataList.map((item) => (
            <Option key={item}>{item}</Option>
          ))}
        </Select>
      ) : null
    },
    {
      name: ['event', 'date'],
      rules: [{ required: true }],
      input: (
        <DatePicker
          initialValues={today}
          format={dateFormat}
          defaultPickerValue={moment()}
        />
      )
    },
    {
      name: ['event', 'comment'],
      rules: [{ required: false }],
      input: <TextArea row={4} />
    }
  ];

  return { eventFields };
};

export default useEventFields;
